export function menu() {

	let menuButton  = $('.js-menu-button');
	let menu        = $('.js-mobile-menu');
	let closeMenu   = $('.js-close-menu');
	let menuLink    = $('.js-mobile-menu a');

	menuButton.on('click', function() {
		menu.addClass('is-active');
	});

	closeMenu.on('click', function() {
		menu.removeClass('is-active');
	});

	menuLink.on('click', function() {
		menu.removeClass('is-active');
	});

	return 'menu';
}